exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".resultsPanel {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border: 1px solid #ebebeb;\n  width: 40%;\n  position: relative;\n  background: #fafafa;\n  color: #494949;\n  display: flex;\n  flex-direction: column; }\n  .resultsPanel .ace_text-layer {\n    padding-left: 12px !important; }\n  .resultsPanel .panelTitle {\n    border-bottom: 1px solid #ebebeb; }\n", ""]);

// exports
